<mat-card *ngIf="order">
  <div fxLayout="row" fxLayoutAlign="center start">
    <a mat-icon-button class="back" routerLink="/validar">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <div fxFlex>
      <mat-card-title fxLayout="row">
        <div fxFlex>Órden: {{order.id}}</div>
        <div>Estado: {{order.internalStatus}}</div>
      </mat-card-title>
      <mat-card-subtitle>Cliente: {{order.clientName}} - ({{order.nit}})</mat-card-subtitle>
    </div>
  </div>
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="end center" class="action-buttons">
      <button mat-button color="primary" (click)="validate()" [disabled]="order.internalStatus !== 'NV' && order.internalStatus !== 'I' ">
        ES VÁLIDA
        <mat-icon aria-label="Validar">check</mat-icon>
      </button>
      <button mat-button color="warn" [matMenuTriggerFor]="menu" [disabled]="order.internalStatus === 'NV'">
        NO ES VÁLIDA
        <mat-icon aria-label="Invalidar">error_outline</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button (click)="invalidate('Falta de calidad')" mat-menu-item>Falta de calidad</button>
        <button (click)="invalidate('Ilegibilidad')" mat-menu-item>Ilegibilidad</button>
        <button (click)="invalidate('Incompleto')" mat-menu-item>Incompleto</button>
        <button (click)="invalidate('Suspendido')" mat-menu-item>Suspendido</button>
      </mat-menu>
    </div>
    <mat-accordion>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> Contenido </mat-panel-title>
        </mat-expansion-panel-header>
        <app-validate-order-table [items]="order.items" [orderid]="order.id"></app-validate-order-table>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Historial </mat-panel-title>
        </mat-expansion-panel-header>
        <app-order-history [orderId]="order.id"></app-order-history>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
